import { B100, B400, B50, B75, DN600, N0, N200, N30, N40, N500, N600, N700, N800, N900 } from '@atlaskit/theme/colors';
var textColor = {
  light: "var(--ds-text, ".concat(N900, ")"),
  dark: "var(--ds-text, ".concat(DN600, ")")
};
var textColorMedium = "var(--ds-text-subtle, ".concat(N600, ")");
var todayColor = {
  light: "var(--ds-text-selected, ".concat(B400, ")"),
  dark: "var(--ds-text-selected, ".concat(B100, ")")
};
var hoverBackground = {
  light: "var(--ds-background-neutral-subtle-hovered, ".concat(N30, ")"),
  dark: "var(--ds-background-neutral-subtle-hovered, ".concat(N800, ")")
};
var textSelected = {
  light: "var(--ds-text-selected, ".concat(N0, ")"),
  dark: "var(--ds-text-selected, ".concat(N700, ")")
};
var selectedBackground = {
  light: "var(--ds-background-selected, ".concat(N500, ")"),
  dark: "var(--ds-background-selected, ".concat(N0, ")")
};
var borderColorFocused = {
  light: "var(--ds-border-focused, ".concat(B100, ")"),
  dark: "var(--ds-border-focused, ".concat(B75, ")")
};
export var dateCellStyles = function dateCellStyles() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  return {
    all: 'unset',
    display: 'block',
    padding: '4px 9px',
    position: 'relative',
    backgroundColor: 'transparent',
    border: '2px solid transparent',
    borderRadius: 3,
    color: textColor[mode],
    cursor: 'pointer',
    fontSize: "var(--ds-font-size-100, 14px)",
    textAlign: 'center',
    '&[data-sibling]': {
      color: "var(--ds-text-subtlest, ".concat(N200, ")")
    },
    '&[data-today]': {
      color: todayColor[mode],
      fontWeight: "var(--ds-font-weight-bold, bold)",
      '&::after': {
        display: 'block',
        height: 2,
        position: 'absolute',
        right: 2,
        bottom: 2,
        left: 2,
        backgroundColor: 'currentColor',
        content: '""'
      }
    },
    '&[data-prev-selected]': {
      backgroundColor: "var(--ds-background-selected, ".concat(B50, ")"),
      color: "var(--ds-text-subtle, ".concat(N600, ")")
    },
    '&[data-selected]': {
      backgroundColor: selectedBackground[mode],
      color: textSelected[mode]
    },
    '&[data-disabled]': {
      color: "var(--ds-text-disabled, ".concat(N40, ")"),
      cursor: 'not-allowed'
    },
    '&[data-focused]': {
      border: "2px solid ".concat(borderColorFocused[mode])
    },
    '&:hover': {
      backgroundColor: hoverBackground[mode],
      color: textColor[mode]
    },
    '&:active': {
      backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat(B50, ")"),
      color: textColor[mode]
    },
    '&[data-selected]:hover': {
      backgroundColor: "var(--ds-background-selected-hovered, ".concat(B50, ")"),
      color: "var(--ds-text-selected, ".concat(N600, ")")
    },
    '&[data-prev-selected]:hover': {
      color: textColorMedium
    },
    '&[data-sibling]:hover': {
      color: "var(--ds-text-subtlest, ".concat(N200, ")")
    },
    '&[data-disabled]:hover': {
      backgroundColor: 'transparent',
      color: "var(--ds-text-disabled, ".concat(N40, ")")
    }
  };
};